module.exports = __webpack_public_path__ + "images/emoji/warning.03ce6b37d57ece096b58.png";